import useLocation from 'lib/hooks/useLocation';
import usePlans from 'lib/hooks/usePlans';

import {
  Card,
  Flag,
  formatCurrency,
  Heading,
  IconList,
  LinkWithButtonStyles,
  Rule,
} from '@frontendmentorio/design-system-v2';

function Included({ children }) {
  return (
    <IconList.Item
      icon={{
        className: 'text-lg text-blue-500',
        name: 'circle-check',
        style: 'solid',
      }}
    >
      {children} <span className="sr-only">(included)</span>
    </IconList.Item>
  );
}

export default function TeamsPlan() {
  const { location } = useLocation();

  if (!location) return <Loader />;

  const { currencyCode: code, locale } = location;

  const { teams } = usePlans();

  return (
    <Card className="flex flex-col gap-5 max-w-[24rem] p-5 desktop:flex-row desktop:max-w-[50rem]">
      <div className="flex flex-col gap-4 desktop:w-1/2">
        <Heading level="4" tagName="span">
          Frontend Mentor for Teams
        </Heading>

        <p className="text-neutral-500">
          Onboard new hires faster and train team members more effectively
          through hands-on practice. All team members gain unlimited Pro access,
          and admins can easily oversee and manage the team.
        </p>

        <LinkWithButtonStyles
          className="w-full desktop:mt-auto"
          href={process.env.NEXT_PUBLIC_TEAMS_PLATFORM_URL}
          target="_blank"
        >
          Learn more <span className="sr-only">(opens in a new tab)</span>
        </LinkWithButtonStyles>
      </div>

      <Rule className="desktop:h-auto desktop:w-[1px]" />

      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-1">
          <span className="font-secondary pb-3 text-lg">Teams</span>

          {teams.discountedPrice < teams.price && (
            <del className="font-bold line-through opacity-40 text-neutral-500">
              {formatCurrency(teams.price / 12, { code, locale })}/seat/mo
            </del>
          )}

          <span className="font-semibold text-2xl">
            {formatCurrency(teams.discountedPrice / 12, { code, locale })}
            <span className="text-lg">/seat/mo</span>
          </span>

          {teams.discountString && (
            <Flag className="brightness-150 px-3">
              {teams.discountString} off
            </Flag>
          )}

          <span className="font-normal pt-1 text-sm text-neutral-500">
            {formatCurrency(teams.discountedPrice, { code, locale })} per seat,
            billed yearly
          </span>
        </div>

        <Rule />

        <IconList>
          <Included>Unlimited Pro access for team members</Included>
          <Included>Unified billing</Included>
          <Included>Team management</Included>
          <Included>Team branding</Included>
          <Included>Bulk discount</Included>
        </IconList>
      </div>
    </Card>
  );
}
